import React, {useState, useEffect} from 'react';
import { format } from 'date-fns';


const ArticleDateSelector = ({selectedRange, fromDate, toDate, handleDateRangeSubmit, datePickerActive, onError}) => {

  const [open, setOpen] = useState(false);
  const [calendarRange, setCalendarRange] = useState(selectedRange);
  const [from, setFrom] = useState(fromDate);
  const [to, setTo] = useState(toDate);
  const [isActive, setIsActive] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      return
    }

    handleDateRangeSubmit(from, to, calendarRange, isActive);
  }, [calendarRange]);

  const renderShowAllButton = () => {
    return (
      <a className='show-all-btn' key={calendarRange} onClick={showAllRange} href="javascript:void(0)">Show all</a>
    )
  }

  const showAllRange = () => {
    setCalendarRange('default');
    setIsActive(false);
  }

  const updateFrom = (e) => {
    setFrom(e.target.value);
  }

  const updateTo = (e) => {
    setTo(e.target.value);
  }

  const applyButton = () => {
    setOpen(false);
    setCalendarRange(from + ' - ' + to);
    setIsActive(true);
  }

  const toggleOpen = () => {
    setOpen(!open);
  }

  const rangeSelector = () => {
    if (open) {
      return(
        <div className="f-dropdown fancy-date-selector-content open" aria-hidden="false">
          <div className="date-inputs-wrap">
            <div className="date-input" style={{width: '165px'}}>
              <label htmlFor="from-3">From</label>
              <input onChange={updateFrom} id="from-3" name="from" type="date" value={from} className="hasDatepicker" min="2009-01-01" max={toDate} onClick={(e) => e.stopPropagation()}/>
            </div>
            <div className="date-input" style={{width: '165px'}}>
              <label htmlFor="to-3">To</label>
              <input onChange={updateTo} id="to-3" name="to" type="date" value={to} className="hasDatepicker" min="2009-01-01" max={toDate} onClick={(e) => e.stopPropagation()}/>
            </div>
          </div>
          <div className="date-filters-wrap">
            <div className="date-filters">
              {renderShowAllButton()}
            </div>
            <input className="button secondary tiny apply-btn"  type="button" value="Apply" onClick={applyButton}/>
            <a className="cancel-btn" onClick={() => setOpen(false)}>Cancel</a>
          </div>
        </div>
      )
    }
  }

  const displaySelectedDays = () => {
    let selectedRange = calendarRange;
    if (selectedRange === 'default') {
      return 'All';
    } else {
      return convertToShortDateFormat(selectedRange);
    }
  }

  const convertToShortDateFormat = (selectedRange) => {
    if (!selectedRange || !selectedRange.includes(' - ')) {
      onError('Invalid Date Range, Please select valid date range'); // Trigger the error in the parent
      return
    }

    let dateRangeArray = selectedRange.split(' - ');

    // Check if both dates are valid
    if (isNaN(new Date(dateRangeArray[0])) || isNaN(new Date(dateRangeArray[1]))) {
      onError('Invalid Date Range,  Please select valid date range'); // Trigger the error in the parent
      return
    }

    let dateFrom = new Date(`${dateRangeArray[0]}T00:00:00`);
    let dateTo = new Date(`${dateRangeArray[1]}T00:00:00`);

    const formattedDateFrom = format(dateFrom, 'MMM d, yyyy');
    const formattedDateTo = format(dateTo, 'MMM d, yyyy');

    return `${formattedDateFrom} - ${formattedDateTo}`;
  }

  const handleActiveClass = () => {
    return datePickerActive ? 'active' : '';
  }

  return(
    <div className='show-for-medium-up calendar-container'>
      <div className='fancy-date-selector'>
        <div role='button' onClick={toggleOpen} className="time-selector-container current">
          <span className={handleActiveClass()}>{displaySelectedDays()}</span>
          <img src="https://gallery.cureusjournals.com/collection/browse-article/calendar-icon.png"/>
          <i className={'fas fa-sort-down ' + handleActiveClass()}/>
          {rangeSelector()}
        </div>
      </div>
    </div>
  )
}

export default ArticleDateSelector;
